import 'react-phone-number-input/style.css';
import { Input, InputBase, InputWrapperProps, TextInputProps } from '@mantine/core';
import { ClipboardEvent, FocusEvent } from 'react';
import PhoneInput, { formatPhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import br from 'react-phone-number-input/locale/pt-BR.json';

type PhoneInputWithLabelProps = {
  label: string;
  onChange: ({ phone, formattedPhone }: { phone: string; formattedPhone: string }) => void;
  value?: string;
  error?: string;
  readOnly?: boolean;
  onBlur?(event: FocusEvent<HTMLElement>): void;
  customInputProps?: TextInputProps;
  ableCountryCode?: boolean;
  hideCountrySelect?: boolean;
} & Omit<InputWrapperProps, 'onChange' | 'onBlur' | 'readOnly'>;

const PhoneInputWithLabel = ({
  label,
  onChange,
  value,
  error,
  onBlur,
  readOnly,
  customInputProps,
  ableCountryCode = true,
  hideCountrySelect = false,
  ...props
}: PhoneInputWithLabelProps) => {
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const text = e.clipboardData
      .getData('text')
      .trim()
      .replace(/[\s\-\(\)\.]/g, '');

    let e164: string | null = null;
    if (text.startsWith('+55')) {
      e164 = text;
    } else if (text.startsWith('55') && text.length > 11) {
      e164 = `+${text}`;
    }

    if (e164) {
      e.preventDefault();
      onChange({ phone: e164, formattedPhone: formatPhoneNumber(e164) });
    }
  };

  return (
    <Input.Wrapper
      p={0}
      mb="md"
      label={label}
      error={error}
      // styles={{ error: { marginTop: 8, fontSize: 16 } }}
      {...props}
    >
      <PhoneInput
        error={!!error}
        flags={flags}
        readOnly={readOnly}
        inputComponent={InputBase}
        labels={br}
        defaultCountry="BR"
        withCountryCallingCode={ableCountryCode} // Remove the default +55
        international={ableCountryCode} // Disable international format
        onBlur={onBlur}
        countrySelectComponent={hideCountrySelect ? () => null : undefined}
        countrySelectProps={{ style: { color: 'black', backgroundColor: 'white' } }}
        numberInputProps={{ ...customInputProps, onPaste: handlePaste }}
        value={value}
        onChange={(value) => {
          onChange({ phone: value as string, formattedPhone: formatPhoneNumber(value as string) });
        }}
      />
    </Input.Wrapper>
  );
};

export default PhoneInputWithLabel;
